"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationCard = void 0;
var react_1 = __importStar(require("react"));
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./AutomationCard.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var AutomationPill_1 = require("Library/AutomationLibrary/Components/AutomationPill");
var AutomationCard = function (props) {
    var automation = props.automation, onClick = props.onClick, options = props.options, disabled = props.disabled, toggleDisabled = props.toggleDisabled, toggleDisabledReason = props.toggleDisabledReason, integrationDisplayName = props.integrationDisplayName;
    var name = automation.name, description = automation.description;
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    var _a = __read((0, react_1.useState)(automation.enabled), 2), enabled = _a[0], setEnabled = _a[1];
    var enableCallback = function (isActive) { return __awaiter(void 0, void 0, Promise, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, props.enableCallback(automation.id, isActive)];
                case 1:
                    _a.sent();
                    notifyUser.success("Automation ".concat(isActive ? "is ON" : "is OFF"));
                    return [3, 3];
                case 2:
                    e_1 = _a.sent();
                    notifyUser.error("Automation cannot be ".concat(isActive ? "enabled" : "disabled"));
                    setEnabled(automation.enabled);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    var debouncedEnableCallback = (0, react_1.useCallback)((0, lodash_1.debounce)(enableCallback, 1000, {
        leading: false,
        trailing: true,
    }), []);
    var onToggle = function (isActive) { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            setEnabled(isActive);
            debouncedEnableCallback(isActive);
            return [2];
        });
    }); };
    return (react_1.default.createElement(kaleidoscope_1.ButtonCard, { onClick: disabled ? lodash_1.noop : onClick, className: styles.cardWrapper, elevation: 1 },
        react_1.default.createElement(kaleidoscope_1.Stack, { justify: "spaceBetween", className: styles.cardContent },
            react_1.default.createElement("div", { className: styles.cardHeadingBlock },
                react_1.default.createElement("div", { className: styles.cardHeadingRow },
                    react_1.default.createElement(kaleidoscope_1.Heading, { className: styles.automationName, level: "4", strong: true }, name),
                    options && (react_1.default.createElement("div", { style: { pointerEvents: "auto" }, onClick: function (e) { return e.stopPropagation(); } },
                        react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null), size: kaleidoscope_1.ButtonSize.Small }), size: "small" }, options.map(function (option, key) { return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { key: key, onClick: option.callback, destructive: option.destructive, className: option.destructive ? styles.destructiveOption : undefined, disabled: disabled }, option.label)); }))))),
                react_1.default.createElement(kaleidoscope_1.Text, { className: styles.description, size: "s" }, description)),
            react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.bottomRow, direction: "horizontal", justify: "spaceBetween" },
                react_1.default.createElement(AutomationPill_1.AutomationPill, { integrationName: automation.integration, integrationDisplayName: integrationDisplayName }),
                react_1.default.createElement("div", { onClick: function (e) { return e.stopPropagation(); } },
                    react_1.default.createElement(kaleidoscope_1.Tooltip, { content: toggleDisabled ? toggleDisabledReason : "Automation ".concat(enabled ? "On" : "Off"), size: kaleidoscope_1.TooltipSize.Small, wrapTarget: true },
                        react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Enable or disable automation", value: enabled, onChange: onToggle, labelHidden: true, disabled: disabled || toggleDisabled })))))));
};
exports.AutomationCard = AutomationCard;
